import { addOrUpdateBusinessInfo } from '../api'

export default {
  data() {
    return {
      businessContactsSchema: [
        {
          label: 'First Name',
          type: 'input',
          key: 'firstName',
        },
        {
          label: 'Last Name',
          type: 'input',
          key: 'lastName',
        },
        {
          label: 'Title',
          type: 'input',
          key: 'title',
        },
        {
          label: 'Email',
          type: 'input',
          key: 'email',
        },
        {
          label: 'Mobile #',
          type: 'input',
          key: 'mobile',
        },
        {
          label: 'Location',
          type: 'select',
          placeholder: 'All',
          key: 'country',
          selectList: [],
        },
      ],
      isShowBusinessContactsForm: false,
    }
  },
  methods: {
    async handleBusinessContactsSaveBtn() {
      try {
        const params = this.$refs.businessContacts.getFormData()
        await addOrUpdateBusinessInfo({
          ...params,
          companyId: this.customerInfo.base.id,
        })
        this.isShowBusinessContactsForm = false
        await this._getCustomerInfo()
      } catch (err) {
        console.error(err)
        return Promise.reject(err)
      }
    },
  },
}
